<template>
  <div class="trainingDetail">
    <nav-header></nav-header>
    <section class="sec1">
      <div class="bannar">
        <div class="tit" v-if="obj">
          {{obj.scourseName}}
        </div>
        <div class="tit2">
          <span class="tit2a">共{{courseMediaList.length}}讲</span>
          <span class="tit2b">{{currentTitle}}</span>
        </div>
        <div class="course">
          <div class="course1">
            <video controls class="video" id="myvideo" v-if="cover && currentFormat == 'MP4'" :autoplay="Isautoplay" muted :src="cover">
              <!-- cover -->
              <!-- http://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/video/1626417507640_b6f72ada.mp4 -->
                <p>Your browser doesn't support HTML5 video. Here is
                  a <a href="">link to the video</a> instead.</p>
            </video>
            <img src="@/assets/training/pdf.png" alt="" class="play" v-else @click="downloadPdf()"/>

            <div class="buy" v-if="isBuy">
              <p>{{tips}}</p>
              <div @click="toBuyTips" v-if="obj">￥{{obj.scoursePrice}} 立即购买</div>
            </div>
          </div>
          <div class="course2">
            <div class="chose">
              <span class="chose1" :class="!isIntro?'act':''" @click="isIntro = false">目录</span>
              <span class="chose2" :class="isIntro?'act':''" @click="isIntro = true">介绍</span>
            </div>
            <div class="content">
              <ul class="contentUl" v-if="!isIntro">
                <li v-for="(item,index) in courseMediaList" :key="index" @click="chapter(index)">
                  <span>{{item.numName}}</span>
                  <span>{{item.smediaName}}</span>
                </li>
              </ul>
              <div class="contentUl intro" v-if="isIntro">
                {{obj.sintro}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="sec2">
      <div class="intoTit">
        <div>考试</div>
        <div class="intoTit">为您推荐</div>
      </div>
      <div class="secMain">
        <div class="detail">
          <div v-if="obj && obj.courseExamList.length>0">
            <div class="test" @click="toTest" v-for="(item,index) in obj.courseExamList" :key="index">{{item.spaperName}}</div>
          </div>
          <div class="test" v-else>本课程暂无考试...</div>

          <div class="detailOrComment">
            <div class="com" :class="!isComment?'detailAct':''" @click="isComment = false">课程详情</div>
            <div class="com com1" :class="isComment?'detailAct':''" @click="isComment = true" v-if="obj">评论{{obj.courseRemarkList.length}}</div>
          </div>
          <div class="detailBox" v-html="obj.scourseDetails" v-if="obj && !isComment">

          </div>

          <div class="commentBox" v-if="isComment">
            <div class="commentInput">
              <el-input class="inputBox" v-model="comVal"></el-input>
              <div class="express" @click="toComment">发表评论</div>
            </div>
            <ul class="commentUl" v-if="obj && obj.courseRemarkList.length>0">
              <li class="commentLi" v-for="(item,index) in obj.courseRemarkList" :key="index">
                <div class="liBox1">
                  <img :src="item.face" alt="" class="head" v-if="item.face"/>
                  <img src="@/assets/training/head.png" alt="" class="head" v-else/>
                  <div class="name">
                    <div>
                      <span class="nameText">{{item.nickname}}</span>
                      <span class="time">{{item.timeShow}}</span>
                    </div>
                    <div class="commentText">{{item.remark}}</div>
                  </div>
                </div>
                <div>
                  <img src="@/assets/training/like.png" alt="" class="like" v-if="!item.isLike" @click="like(1,item.pkid)">
                  <img src="@/assets/training/liked.png" alt="" class="like" v-if="item.isLike" @click="like(0,item.pkid)">
                </div>
              </li>
              
            </ul>
            <ul v-else class="commentUl">
              <li class="commentLi">
                暂无评论...
              </li>
            </ul>
          </div>


        </div>

        <div class="recom">
          <ul v-if="recommendList.length>0">
            <li class="every" v-for="(item,index) in recommendList" :key="index" @click="resetInit(item.scourseNo)">
              <img :src="item.scoverImageUrl" alt="" class="courseImg">
              <p>{{item.scourseName}}</p>
              <span v-if="item.mediaCount == 1 && item.smediaFormat == 'MP4'"
            v-text="toTime(item.stimeSpan)"></span>
              <span v-else>{{item.mediaCount}}课</span>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <dark-footer></dark-footer>
  </div>
</template>
<script>
import NavHeader from "@/components/navHeader.vue";
import DarkFooter from "@/components/darkFooter.vue";
import {aesDecrypt,aesEncrypt} from '@/scripts/aesHelper.js'
import {
  detailCourse,recommend,courseRemark,likeRemark,learnAdd,ConfirmOrderByCourse,
} from "@/scripts/api.js";
import { mapState } from "vuex";
const BMap = window.BMap;
export default {
  components: {
    NavHeader,
    DarkFooter,
  },
  data() {
    return {
      courseMediaList:[],
      obj:null,
      cover:'',
      currentTitle:'',
      isIntro:false,
      isComment:false,
      recommendList:[],
      comVal:'',
      tips:'抱歉，该课程需购买后才能继续学习',
      price:'0',
      isBuy:false,
      chapterIndex:0,
      last_play_time:0,
      isFirst:true,
      courseNo:'',
      Isautoplay:false,
      currentFormat:'MP4'
    };
  },
  computed: {
    ...mapState({
      userInfo: (state) => state.userInfo,
    }),
  },
  created() {},
  mounted() {
    this.init()
    this.getRecommend()

    
  },
  methods: {
    record(courseNo){
      var data = {
        platform: 'pcweb',
        scourseNo: courseNo,
      }
      if(this.userInfo) data.userId = this.userInfo.LoginAccountId
      if(this.userInfo) data.userType = this.userInfo.LoginAccountType
      learnAdd(data).then((r)=>{
        if(r.Result == 1){
          console.log(r)
        }
      })
    },
    toTime(time1) {
      if (!time1) return "00:00:00";
      var time = Number(time1);


      let hour = Math.floor(time / 60 / 60);

      hour = hour.toString().padStart(2, "0");

      let minute = Math.floor(time / 60) % 60;

      minute = minute.toString().padStart(2, "0");

      let second = Math.floor(time) % 60;

      second = second.toString().padStart(2, "0");
      var a = `${hour}:${minute}:${second}`;
      return a;
    },
    toBuyTips(){
      let self = this
      if(!this.userInfo){
        this.$toast('请先登录')
        return 
      }
        var data = {
          "Scourse_no":this.courseNo,
          "UserCode":this.userInfo.UserCode,
          "UserCouponId":0,
          "platform":"pcweb",
        }
        ConfirmOrderByCourse(data).then((r)=>{
          if(r.Result == 1){
            // var temp = '//c.gongkongbpo.qa'
            // var teme = '//www.gongkongbpo.qa'
            // var url;
            // if(location.host == 'ts.insupai.com'){//预生产
            //   temp='//tc.insupai.com'
            //   teme='//ts.insupai.com'
            // }
            // if(location.host == 'www.insupai.com'){//生产
            //   temp='//c.insupai.com'
            //   teme='//www.insupai.com'
            // }
            // if(self.userInfo.LoginAccountType ==1) {
            //   url = `${teme}/BpoPay/UserPayView?payId=${r.Data.PayId}`
            // }else{
            //   url = `${temp}/BpoPay/CompanyPayView?payId=${r.Data.PayId}`
            // }
            // window.open(url,'_self');

            this.$router.push({
              path:'/payment',
              query:{
                payId:r.Data.PayId,
                from:4
              }
            });

          }
        })
    },
    getVideo() {
      console.log("执行getVideo");
			var myvideo = document.getElementById("myvideo");
      if(!myvideo) return
			var that = this;
			myvideo.addEventListener("timeupdate", function() {
				that.last_play_time = Math.floor(myvideo.currentTime);
        console.log(that.last_play_time)
        if(that.last_play_time>=60*5 && that.obj.nchargeTypeId == 3 && that.obj.isBuy == 0){
          myvideo.pause()
          that.isBuy = true;
        }
			});
		},
    isPlay(){
      // 1        免费
      // 2        首节免费
      // 3        试看五分钟
      // 4        全部收费
      //nchargeTypeId
       if(this.obj.isBuy == 1){
        this.isBuy = false;
        return
      }
      if(this.obj.courseMediaList[0].smediaFormat == 'PDF' && this.obj.nchargeTypeId == 3){
        this.isBuy = true;
        return
      }
      if(this.obj.nchargeTypeId == 1){
        this.isBuy = false;
        return
      }
      if(this.obj.nchargeTypeId == 3){
        this.isBuy = false;
        return
      }
      if(this.obj.nchargeTypeId == 2 && this.chapterIndex ==0){
        this.isBuy = false;
        return
      }

      this.isBuy = true

    },
    like(type,id){
      const _this = this;
      var data = {
          courseRemarkId: id,
          likes: type,
          platform: 'pcweb',
      }
      if(this.userInfo) data.userId = this.userInfo.LoginAccountId
      if(this.userInfo) data.userType = this.userInfo.LoginAccountType
      likeRemark(data).then((r)=>{
        if(r.Result == 1){
          _this.init()
        }
      })
    },
    toComment(){
      const _this = this
      if(!this.comVal){
        this.$toast('评论内容不能为空')
        return
      }
      var data = {
        platform:'pcweb',
          remark: this.comVal,
        scourseNo: this.obj.scourseNo,
      }
      if(this.userInfo) data.userId = this.userInfo.LoginAccountId;
      if(this.userInfo) data.userType = this.userInfo.LoginAccountType;
      courseRemark(data).then((r)=>{
        if(r.Result == 1){
          _this.$toast('评论成功')
          _this.comVal = ""
          _this.init();
        }
      })
    },
    getRecommend(){
      const _this = this
      var data = {
        platform : 'pcweb'
      }
      recommend(data).then((r)=>{
        if(r.Result == 1){
          const {Data} = r
          _this.recommendList = Data.slice(0,3) || [];
        }
      })
    },
    toTest(){
      this.$toast('请移步到工业速派app进行考试谢谢!')
    },
    downloadPdf(){
      window.location.href = aesDecrypt(this.courseMediaList[this.chapterIndex].sfileUrl,2)
    },
    isShowBuy(i){
      // 1        免费
      // 2        首节免费
      // 3        试看五分钟
      // 4        全部收费
      //nchargeTypeId
       if(this.obj.isBuy == 1){
        this.isBuy = false;
        return
      }
      if(this.obj.courseMediaList[i].smediaFormat == 'PDF' && this.obj.nchargeTypeId == 3){
        this.isBuy = true;
        return
      }
      if(this.obj.nchargeTypeId == 1){
        this.isBuy = false;
        return
      }
      if(this.obj.nchargeTypeId == 3){
        this.isBuy = false;
        return
      }
      if(this.obj.nchargeTypeId == 2 && this.chapterIndex ==0){
        this.isBuy = false;
        return
      }

      this.isBuy = true

    },
    chapter(i){
      this.chapterIndex = i;
      this.cover = aesDecrypt(this.courseMediaList[i].sfileUrl,2)
      this.currentTitle = this.courseMediaList[i].smediaName
      this.currentFormat = this.courseMediaList[i].smediaFormat

      if(document.getElementById("myvideo")) document.getElementById("myvideo").load();
      

      // if(this.obj.nchargeTypeId>=2 && i>=1){
      //   this.isBuy = true
      //   this.Isautoplay = false;
      // }else{
      //   this.isBuy = false
      // }
      // if(this.obj.isBuy == 1){
      //    this.isBuy = false
      // }
      if(this.obj.nchargeTypeId>=2 && i>=1 && this.obj.isBuy == 0){
        this.Isautoplay = false;
      }
      this.isShowBuy(i)
      if(i<=0){
        this.init()
      }

    },
    resetInit(No){
      this.record(No)
      this.courseNo = No;
      this.init()
      this.getRecommend()
    },
    init(){
      const _this = this
      if(this.isFirst) this.courseNo = this.$route.query.id
      this.isFirst = false;

      var data = {
        platform : 'pcweb',
        scourseNo : this.courseNo,
      }
      if(this.userInfo) data.nuserId = this.userInfo.LoginAccountId
      if(this.userInfo) data.nuserType = this.userInfo.LoginAccountType
      detailCourse(data).then((r)=>{ 
        if(r.Result == 1){
          const {Data} = r
          _this.obj = Data
          _this.courseMediaList = Data.courseMediaList || []
          _this.cover = aesDecrypt(_this.courseMediaList[0].sfileUrl,2)
          _this.currentTitle = _this.courseMediaList[0].smediaName
          _this.currentFormat = _this.courseMediaList[0].smediaFormat
          _this.isPlay()
          _this.$forceUpdate()
          
          if(_this.obj.nchargeTypeId == 4){
            _this.Isautoplay = false;
          }else{
            _this.Isautoplay = true;
          }
         
          // document.getElementById("myvideo").load(); //放到nextTick里面
          _this.$nextTick(()=>{
            // console.log(document.getElementById("myvideo"));
            document.getElementById("myvideo").load();
            _this.getVideo()
          })

        }
      })
    },
  },
};
</script>
<style lang="scss">
.trainingDetail {
  .sec1 {
    width: 100%;
    height: 655px;
    background-color: #191919;
    margin-top: 69px;
    .bannar {
      width: 1200px;
      margin: 0 auto;
      .tit {
        font-size: 24px;
        color: #ffffff;
            padding-top: 22px;
    margin-bottom: 14px;
        width: 860px;
         
display: -webkit-box;
-webkit-box-orient: vertical;
-webkit-line-clamp: 2;
overflow: hidden;
      }
      .tit2 {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        font-size: 16px;
        color: #ffffff;
        line-height: 16px;
            width: 860px;
            
        .tit2a {
          padding-right: 15px;
          border-right: 1px solid #fff;
              display: block;
    white-space: nowrap;
        }
        .tit2b {
          padding-left: 15px;
        }
      }
      .course {
        width: 100%;
        width: 1200px;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        margin-top: 22px;
        .course1 {
          width: 860px;
          height: 500px;
          text-align: center;
          position: relative;
          .buy{
            width: 860px;
            height: 500px;
            background-color: rgba(0,0,0,0.6);
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
            p{
              font-size: 24px;
              color: #ffffff;
              width: 100%;
              text-align: center;
              position: absolute;
              top: 188px;
            }
            div{
              background-color: #f75959;
              border-radius: 10px;
              padding: 5px 12px;
              position: absolute;
              top: 254px;
              left: 50%;
              transform: translateX(-50%);
              font-size: 28px;
	            color: #ffffff;
            }
          }
          .video {
            width: 860px;
            height: 500px;
          }
          .play {
            width: 84px;
            height: 84px;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            cursor: pointer;
          }
        }
        .course2 {
          width: 340px;
          height: 500px;
          background-color: #2d2d2d;
          .chose {
            width: 100%;
            height: 64px;
            border-bottom: 1px solid #191919;
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            span {
              display: block;
              height: 64px;
              line-height: 64px;
              font-size: 16px;
              color: #ffffff;
              cursor: pointer;
            }
            .act {
              border-bottom: 1px solid #f75959;
            }
            .chose1 {
              margin-left: 83px;
            }
            .chose2 {
              margin-right: 83px;
            }
          }
          .content {
            margin-top: 34px;
            /* 设置滚动条的样式 */
            ::-webkit-scrollbar {
              width: 8px;
            }
            /* 滚动槽 */
            ::-webkit-scrollbar-track {
              -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.3);
              border-radius: 10px;
            }
            /* 滚动条滑块 */
            ::-webkit-scrollbar-thumb {
              border-radius: 10px;
              background: rgba(0, 0, 0, 0.1);
              -webkit-box-shadow: inset006pxrgba(0, 0, 0, 0.5);
            }
            ::-webkit-scrollbar-thumb:window-inactive {
              background: rgba(255, 255, 255, 0.2);
            }
            .intro {
              font-size: 16px;
              color: #666666;
              width: 288px;
              margin: 0 auto;
              word-break: break-all;
            }
            .contentUl {
              height: 401px;
              overflow-y: auto;
              li {
                width: 144px;
                height: 84px;
                background-color: #333333;
                display: inline-block;
                text-align: center;
                font-size: 16px;
                color: #ffffff;
                margin-bottom: 20px;
                &:nth-child(2n-1) {
                  margin-left: 20px;
                }
                &:nth-child(2n) {
                  margin-left: 12px;
                }
                span {
                  display: block;
                  &:nth-child(1) {
                    margin: 10px auto;
                  }
                  &:nth-child(2) {
                    width: 121px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin: 0 auto;
                    cursor: pointer;
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .sec2 {
    width: 1200px;
    margin: 58px auto 71px;
    .intoTit {
      margin-bottom: 28px;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      font-size: 28px;
      color: #333;
      .intoTit {
        margin-right: 96px;
      }
    }
    .secMain {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }
    .detail {
      width: 860px;
      .test {
        width: 860px;
        height: 58px;
        background-color: #ffffff;
        box-shadow: 0px 2px 20px 0px rgba(33, 23, 20, 0.1);
        border-radius: 10px;
        border: solid 1px #f75959;
        margin-bottom: 9px;
        text-align: center;
        line-height: 58px;
        font-size: 24px;
        color: #333333;
        cursor: pointer;
      }
      .detailOrComment {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 33px;
        margin-top: 30px;
        .com {
          font-size: 28px;
          color: #999999;
          padding-bottom: 10px;
          cursor: pointer;
        }
        .com1 {
          margin-left: 93px;
        }
        .detailAct {
          font-size: 28px;
          color: #333333;
          position: relative;
          &::after {
            content: "";
            display: block;
            position: absolute;
            left: 50%;
            bottom: 0px;
            transform: translateX(-50%);
            width: 36px;
            height: 4px;
            background-color: #f75959;
          }
        }
        
      }
      .detailBox {
          width: 100%;
        }
        .commentBox {
          width: 100%;
          .commentInput{
            width: 859px;
            height: 49px;
            border-radius: 10px;
            border: solid 1px #e0e0e0;
            overflow:hidden;
            position: relative;
            .inputBox{
              width: 859px;
            height: 49px;
              position: absolute;
              left: 0;
              top: 0;
              .el-input__inner{
                height: 48px;
                line-height: 48px;
                border: none;
                background: none;
                }
            }
            .express{
              position: absolute;
              right: -1px;
              top: -1px;
              width: 92px;
              height: 49px;
              background-color: #f75959;
              border-radius: 0px 10px 10px 0px;
              text-align: center;
              line-height: 48px;
              font-size: 16px;
              color: #ffffff;
              cursor: pointer;
            }
          }
          .commentUl{
            margin-top: 60px;
            .commentLi{
              display: flex;
              flex-direction: row;
              align-items: flex-start;
              justify-content: space-between;
              margin-bottom: 60px;
              .liBox1{
                display: flex;
                flex-direction: row;
                align-items: flex-start;
                .head{
                  width: 44px;
                  height: 44px;
                  margin-right: 19px;
                  border-radius: 50%;
                }
                .name{
                  display: flex;
                  flex-direction: column;
                  justify-content: space-between;
                  align-items: flex-start;
                  font-size: 16px;
                  .nameText{
                    color: #f75959;
                    margin-right: 9px;
                  }
                  .time{
                    color: #999999;
                  }
                  .commentText{
                    color: #333333;
                    display:block;
    white-space: normal;
    word-break: break-word;
                  }
                }
              }
              .like{
                width: 26px;
	height: 26px;
  margin-right: 34px;
  cursor: pointer;
  margin-top: 20px;
              }

            }
          }
        }
    }
    .recom {
      width: 300px;
      .every{
        width: 300px;
        position: relative;
        margin-bottom: 29px;
        cursor: pointer;
        .courseImg{
          width: 300px;
          height: 151px;
        }
        p{
          font-size: 16px;
          color: #333333;
          margin-top: 15px;
          width: 100%;
          overflow: hidden;
text-overflow:ellipsis;
white-space: nowrap;
        }
        span{
          display: block;
          position: absolute;
          padding: 5px 8px;
          font-size: 12px;
	color: #ffffff;
  background-color: rgba(0,0,0,0.6);
  top: 119px;
  right: 12px;
  border-radius: 4px;
        }
      }
    }
  }
}
</style>